/* eslint-disable */

import DOMPurify from 'dompurify';

const decCases = [2, 0, 1, 1, 1, 2];

export function decOfNum(n, titles) {
  const a = n % 100 > 4 && n % 100 < 20 ? 2 : decCases[Math.min(n % 10, 5)];
  return titles[a];
}

export function downloadFileHelper(resp) {
  if (resp.error) {
    throw new Error(`Ошибка: ${resp.error}`);
  }
  fetch(resp.link)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Ошибка загрузки: ${response.statusText}`);
      }
      return response.blob();
    })
    .then(blob => {
      const urlParts = resp.link.split('/');
      const filename = urlParts[urlParts.length - 1] || 'file.pdf';
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    })
    .catch(err => console.error('Ошибка:', err));
}

export function toFloat(v) {
  if (typeof v === 'string') {
    v = v.replace(',', '.');
  }
  const parsed = parseFloat(v);
  if (v === '' || v === null || v === undefined) {
    v = 0;
  } else if (!Number.isNaN(parsed)) {
    v = parsed;
  }
  return v;
}

export function checkFloat(v) {
  if (typeof v === 'string') {
    v = v.replace(',', '.');
  }
  if (Number.isNaN(+v) || (typeof v === 'string' && v[v.length - 1] === '.')) {
    return 'Введите число';
  }
}

export function escapeHtml(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function sanitizeBrHtml(text) {
  if (!text) return text;
  return escapeHtml(text).replace(/&lt;br\s*\/?&gt;/gi, '<br>');
}

// Санитизация HTML из rich-text редактора (HtmlContentEditor.vue / Tiptap)
// перед v-html — итоговый комментарий эксперта хранится в БД и приходит через
// API, а не только из редактора, поэтому его нельзя считать безопасным HTML
// (см. аудит XSS в expert_conclusion). Белый список ограничен тем, что реально
// может произвести редактор (StarterKit + TextAlign + Link + CustomImage).
const RICH_HTML_PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'hr', 'b', 'strong', 'i', 'em', 's', 'strike', 'u',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li', 'blockquote', 'code', 'pre', 'a', 'img',
  ],
  ALLOWED_ATTR: ['style', 'href', 'rel', 'target', 'src', 'alt', 'width', 'height'],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|data:image\/|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
};

// DOMPurify не фильтрует значение атрибута style (пропускает его как есть) —
// редактор пишет туда только "text-align: <value>", поэтому вырезаем всё
// остальное сами (иначе через style можно, например, слить данные о просмотре
// отчёта на внешний домен через background: url(...)).
const SAFE_TEXT_ALIGN = /^text-align\s*:\s*(left|right|center|justify)\s*;?$/i;
DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName === 'style' && !SAFE_TEXT_ALIGN.test(data.attrValue.trim())) {
    data.keepAttr = false;
  }
});

export function sanitizeRichHtml(html) {
  if (!html) return html;
  return DOMPurify.sanitize(html, RICH_HTML_PURIFY_CONFIG);
}

export function prepareText(text) {
  if (text){
    const lines = text.split('\n');
    let html = '';
    lines.forEach(line => {
      const spaces = line.match(/^\s*/)[0].length;
      const indent = '&nbsp;&nbsp;'.repeat(spaces);
      html += `<p>${indent}${escapeHtml(line.trim())}</p>`;
    });
    return html;
  }

}

export function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h;
  let s;
  const l = (max + min) / 2;

  if (max === min) {
    h = 0;
    s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
      default: console.error('rgbToHsl');
    }
    h /= 6;
  }
  return [h * 360, s * 100, l * 100];
}

export function hslToRgb(h, s, l) {
  h /= 360;
  s /= 100;
  l /= 100;
  let r;
  let g;
  let b;

  if (s === 0) {
    r = l;
    g = l;
    b = l;
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`;
}

// export function hexToRgb(hex) {
//   hex = hex.replace(/^#/, '');
//   if (hex.length !== 6) {
//     return [0, 0, 0];
//   }

//   const r = parseInt(hex.slice(0, 2), 16);
//   const g = parseInt(hex.slice(2, 4), 16);
//   const b = parseInt(hex.slice(4, 6), 16);

//   return [r, g, b];
// }

export function waitFor(predicateFn, timeout = 5000, interval = 100) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const timer = setInterval(() => {
      if (predicateFn()) {
        clearInterval(timer);
        resolve(true);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('⏱ Timeout'));
      }
    }, interval);
  });
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function hexToRgb(hex) {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  if (hex.length !== 6) {
    throw new Error('Некорректный формат hex цвета');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return [r, g, b];
}


export function createUUID() {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i += 1) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((+s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  return s.join('');
}
export function calculateTotalPage({count, page_size}) {
  if (!count || !page_size || page_size <= 0) {
    return 0;
  }

  const totalPages = Math.ceil(count / page_size);
  console.log(`Total items: ${count}, Page size: ${page_size}, Total pages: ${totalPages}`);

  return totalPages;
}
export function formatDate(dateStr) {
  const date = new Date(dateStr);
  const formatter = new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: 'Europe/Moscow'
  });
  return formatter.format(date);
}
